import { isNil } from "lodash";
import React from "react";
import { Nullish } from "utility-types";

export interface Position {
  x: number;
  y: number;
  left: number;
  right: number;
  top: number;
  bottom: number;
  width: number;
  height: number;
}

export const getAbsolutePosition = <T extends HTMLElement>(element: T): Position => {
  const { left, right, top, bottom } = element.getBoundingClientRect();
  const x = (left + right) / 2;
  const y = (top + bottom) / 2;
  const width = right - left;
  const height = bottom - top;
  return { x, y, left, right, top, bottom, width, height };
};

export const getRelativePosition = <T extends HTMLElement>(element: T): Position => {
  const left = element.offsetLeft;
  const right = element.offsetLeft + element.clientWidth;
  const top = element.offsetTop;
  const bottom = element.offsetTop + element.clientHeight;
  const x = (left + right) / 2;
  const y = (top + bottom) / 2;
  const width = right - left;
  const height = bottom - top;
  return { x, y, left, right, top, bottom, width, height };
};

export const isPositionEqual = (
  position1: Position | Nullish,
  position2: Position | Nullish,
): boolean => {
  if (!isNil(position1) && !isNil(position2)) {
    return (
      position1.x === position2.x &&
      position1.y === position2.y &&
      position1.left === position2.left &&
      position1.right === position2.right &&
      position1.top === position2.top &&
      position1.bottom === position2.bottom &&
      position1.width === position2.width &&
      position1.height === position2.height
    );
  }
  return position1 === position2;
};

interface SpacerProps {
  width?: number | string;
  height?: number | string;
  grow?: number;
  shrink?: number;
  children?: React.ReactNode;
}

export const Spacer = (props: SpacerProps) => {
  const style = {
    width: typeof props.width === "number" ? props.width + "px" : props.width || "1px",
    height: typeof props.height === "number" ? props.height + "px" : props.height || "1px",
    flexGrow: props.grow,
    flexShrink: props.shrink,
  };
  return React.createElement("div", { style }, props.children);
};
